(function () {
  'use strict';

  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
    return null;
  }

  function initCountdowns() {
    var timers = document.querySelectorAll('[data-a-cd]');
    if (!timers.length) return;
    var hours = parseInt(timers[0].getAttribute('data-hours'), 10) || 0;
    var minutes = parseInt(timers[0].getAttribute('data-minutes'), 10) || 0;
    var span = (hours * 3600 + minutes * 60) * 1000 || 12 * 3600 * 1000;
    var key = 'a_cd_end_' + span;
    var end = parseInt(store(key), 10);
    var now = Date.now();
    if (!end || end <= now || end - now > span) {
      end = now + span;
      store(key, String(end));
    }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        end = Date.now() + span;
        store(key, String(end));
        left = span;
      }
      var s = Math.floor(left / 1000);
      var h = Math.floor(s / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      timers.forEach(function (t) {
        var eh = t.querySelector('[data-a-cd-h]');
        var em = t.querySelector('[data-a-cd-m]');
        var es = t.querySelector('[data-a-cd-s]');
        if (eh) eh.textContent = pad(h);
        if (em) em.textContent = pad(m);
        if (es) es.textContent = pad(sec);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) n--;
    }
    return d;
  }

  function initShipBy() {
    var els = document.querySelectorAll('[data-a-shipby]');
    if (!els.length) return;
    els.forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
      if (isNaN(cutoff)) cutoff = 14;
      var now = new Date();
      var weekday = now.getDay() !== 0 && now.getDay() !== 6;
      var lead = weekday && now.getHours() < cutoff ? 1 : 2;
      var ship = addBusinessDays(now, lead);
      el.textContent = DAYS[ship.getDay()] + ', ' + MONTHS[ship.getMonth()] + ' ' + ship.getDate();
    });
  }

  function initGalleries() {
    document.querySelectorAll('[data-a-gal]').forEach(function (gal) {
      var track = gal.querySelector('[data-a-gal-track]');
      var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-a-gal-slide]'));
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-a-gal-thumb]'));
      var thumbRow = gal.querySelector('[data-a-gal-thumbs]');
      if (!track || slides.length < 2) return;
      var current = 0;

      function setActive(i) {
        current = i;
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        var t = thumbs[i];
        if (t && thumbRow) {
          var left = t.offsetLeft - thumbRow.clientWidth / 2 + t.clientWidth / 2;
          thumbRow.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      }

      function go(i) {
        if (i < 0) i = slides.length - 1;
        if (i >= slides.length) i = 0;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      }

      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
      var prev = gal.querySelector('[data-a-gal-prev]');
      var next = gal.querySelector('[data-a-gal-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current && i >= 0 && i < slides.length) setActive(i);
        });
      }, { passive: true });
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-a-tabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(n);
          n.focus();
        });
      });
    });
  }

  function initReviews() {
    document.querySelectorAll('[data-a-rev]').forEach(function (root) {
      var btn = root.querySelector('[data-a-rev-more]');
      if (!btn) return;
      var step = parseInt(root.getAttribute('data-step'), 10) || 4;
      btn.addEventListener('click', function () {
        var hidden = root.querySelectorAll('[data-a-rev-item][hidden]');
        for (var i = 0; i < hidden.length && i < step; i++) hidden[i].hidden = false;
        if (root.querySelectorAll('[data-a-rev-item][hidden]').length === 0) btn.hidden = true;
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-a-sticky]');
    if (!bar) return;
    var target = document.querySelector('[data-a-buy]');
    var btn = bar.querySelector('[data-a-sticky-btn]');
    if (btn && target) {
      btn.addEventListener('click', function (e) {
        var atc = target.querySelector('button[type="submit"][name="add"]');
        if (!atc) return;
        e.preventDefault();
        atc.click();
      });
    }
    if (!target) return;
    var anchor = target.querySelector('[data-a-buy-btn]') || target;
    var footer = document.querySelector('.a-foot');
    var ticking = false;
    function update() {
      ticking = false;
      var passed = anchor.getBoundingClientRect().bottom < 0;
      var footerIn = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      bar.classList.toggle('is-on', passed && !footerIn);
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function initScrollLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      var top = el.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  function init() {
    initCountdowns();
    initShipBy();
    initGalleries();
    initTabs();
    initReviews();
    initSticky();
    initScrollLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () {
    initShipBy();
    initGalleries();
    initTabs();
    initReviews();
  });
})();
